/* A presentation layer over CPB's original size controls. CPB remains the
   authority for dimensions, limits, configuration persistence and pricing. */
(function () {
  'use strict';
  if (location.pathname !== '/products/custom-infinity-mirror') return;
  var IDs = {
    mode: 'LB4oi7z56Ta0OZehKxWNh6o0', preset: 'ChhzZNLNHc6HoBDjegeEYT4G', custom: 'hHvqdwVPeJimgKlbmK7ysr_Y',
    units: 'SAvhX7xAkC66xUbZf1toKKOW', inches: 'qozMiWf1p8mmW7MYIUZWAx8q',
    inchFields: 'aE4hNil-ULOoL_nuXhFekRZl', cmFields: 'dbIF9OR5ZazT43lgZsJxGlfh',
    shape: '9Qos5yoFhBABVdL2vB4VBl0o'
  };
  var names = ['compact', 'classic', 'statement', 'gallery', 'feature', 'grand'];
  var lengths = [18, 24, 36, 48, 60, 72];
  var sliderMax = 96;
  var labels = window.__MYX_SIZE_LABELS__;
  if (!labels) return;
  var host, pending, running = false, debounce = 0, refreshTimer = 0, lastShape = '';
  function category(id) { return document.querySelector('#product-builder [data-category-id="' + id + '"]'); }
  function option(id) { return document.querySelector('#product-builder [data-option-id="' + id + '"]'); }
  function active(node) { return node && (node.classList.contains('cpb-active') || node.getAttribute('aria-pressed') === 'true' || node.getAttribute('aria-checked') === 'true'); }
  function shape() {
    var node = category(IDs.shape)?.querySelector('.cpb-active');
    return node?.getAttribute('data-maytrix-shape') || '';
  }
  function square(kind) { return ['square', 'circle', 'octagon'].includes(kind); }
  function vertical(kind) { return ['vrect', 'voval', 'arch'].includes(kind); }
  function dimensions(long, kind) {
    var short = square(kind) ? long : long / 2;
    return { width: vertical(kind) ? short : long, height: vertical(kind) ? long : short };
  }
  function fields() {
    var inches = category(IDs.inchFields), cm = category(IDs.cmFields), node = inches || cm;
    var inputs = node && Array.from(node.querySelectorAll('.cpb-counter input[type="number"]'));
    return inputs?.length === 2 ? { inputs: inputs, factor: inches ? 1 : 2.54 } : null;
  }
  function current() {
    var kind = shape();
    if (!kind) return null;
    if (active(option(IDs.preset))) {
      var selected = window.__MAYTRIX_SIGNATURE_SIZES__?.getSelection(kind);
      return selected ? { width: selected.width, height: selected.height } : null;
    }
    var controls = fields();
    if (!controls) return null;
    var width = Number(controls.inputs[0].value) / controls.factor;
    var height = Number(controls.inputs[1].value) / controls.factor;
    return Number.isFinite(width) && Number.isFinite(height) ? { width: width, height: height } : null;
  }
  function equal(a, b) { return a && b && Math.abs(a.width - b.width) < 0.005 && Math.abs(a.height - b.height) < 0.005; }
  function number(value) { return String(Number(value.toFixed(2))); }
  function dimensionLabel(value) { return number(value.width) + '″ × ' + number(value.height) + '″'; }
  function text(node, value) { if (node.textContent !== value) node.textContent = value; }
  function attr(node, name, value) { if (node.getAttribute(name) !== String(value)) node.setAttribute(name, value); }
  function element(tag, className, content) {
    var node = document.createElement(tag); if (className) node.className = className;
    if (content) node.textContent = content; return node;
  }
  function button(className, content) { var node = element('button', className, content); node.type = 'button'; return node; }
  function make() {
    var wrap = element('div', 'myx-unified-size');
    var grid = element('div', 'myx-size-grid'); grid.setAttribute('role', 'group'); grid.setAttribute('aria-label', 'Size');
    names.forEach(function (name, index) {
      var card = button('myx-size-card'); card.dataset.sizeIndex = index;
      card.append(element('strong', 'myx-size-name', labels[name]), element('span', 'myx-size-dimensions'), element('span', 'myx-size-badge', '★ ' + labels.recommended));
      card.addEventListener('click', function () { queue(dimensions(lengths[index], shape()), 0); }); grid.append(card);
    });
    wrap.append(grid);
    var scale = element('details', 'myx-size-scale');
    var summary = element('summary', 'myx-size-summary');
    summary.append(element('span', '', labels.scale), element('span', 'myx-size-summary-value'));
    scale.append(summary);
    var output = element('output'); output.htmlFor = 'myx-unified-scale';
    var range = element('input'); range.type = 'range'; range.id = 'myx-unified-scale';
    range.setAttribute('aria-label', labels.scale);
    function scaleChange(event) { queue(dimensions(Number(range.value), shape()), event.type === 'change' ? 0 : 100); }
    range.addEventListener('input', scaleChange); range.addEventListener('change', scaleChange); scale.append(range); wrap.append(scale);
    var footer = element('div', 'myx-size-scale-footer');
    var manual = button('myx-size-manual-link', labels.custom);
    manual.setAttribute('aria-expanded', 'false'); manual.setAttribute('aria-controls', 'myx-manual-size-fields');
    footer.append(output, manual); scale.append(footer);
    var rows = element('div', 'myx-size-counters'); rows.id = 'myx-manual-size-fields'; rows.hidden = true;
    manual.addEventListener('click', function () {
      rows.hidden = !rows.hidden; manual.setAttribute('aria-expanded', String(!rows.hidden));
    });
    ['width', 'height'].forEach(function (axis) {
      var field = element('div', 'myx-size-field'), fieldLabel = element('label', '', labels[axis]);
      fieldLabel.htmlFor = 'myx-unified-' + axis;
      var controls = element('div', 'myx-size-counter'), input = element('input');
      input.type = 'number'; input.inputMode = 'decimal'; input.id = fieldLabel.htmlFor; input.step = '0.1'; input.min = '0';
      input.setAttribute('aria-label', labels[axis] + ' in inches');
      var minus = button('', '−'), plus = button('', '+');
      minus.setAttribute('aria-label', labels.decrease + ' ' + labels[axis].toLowerCase());
      plus.setAttribute('aria-label', labels.increase + ' ' + labels[axis].toLowerCase());
      function step(direction) {
        var value = pending || current(); if (!value) return;
        var next = { width: value.width, height: value.height };
        next[axis] = Number((next[axis] + direction * Number(input.step)).toFixed(2));
        if (next[axis] < Number(input.min) || (input.max !== '' && next[axis] > Number(input.max))) return;
        queue(next, 80);
      }
      minus.addEventListener('click', function () { step(-1); }); plus.addEventListener('click', function () { step(1); });
      function edit(event) {
        event.stopPropagation();
        if (!input.checkValidity() || input.value === '') { paint(); return; }
        var value = pending || current(); if (!value) return;
        var next = { width: value.width, height: value.height }; next[axis] = Number(input.value); queue(next, event.type === 'input' ? 220 : 0);
      }
      input.addEventListener('input', edit); input.addEventListener('change', edit);
      input.addEventListener('keydown', function (event) { if (event.key === 'Enter') { event.preventDefault(); input.blur(); } });
      controls.append(minus, input, element('span', 'myx-size-unit', 'in'), plus); field.append(fieldLabel, controls); rows.append(field);
    });
    scale.append(rows);
    var preview = button('myx-customizer-support__preview myx-size-room-preview');
    preview.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M8 3H3v5m13-5h5v5M3 16v5h5m13-5v5h-5" stroke-linecap="round" stroke-linejoin="round"/><rect x="7" y="7" width="10" height="10" rx="1.5"/></svg><span class="myx-size-preview-copy"><strong></strong><small></small></span>';
    preview.querySelector('strong').textContent = labels.preview;
    preview.querySelector('small').textContent = labels.previewDetail;
    preview.addEventListener('click', async function () {
      // Finish the latest size update before the room preview snapshots it.
      if (preview.disabled) return;
      preview.disabled = true;
      clearTimeout(debounce); flush();
      var started = Date.now();
      while ((running || pending) && Date.now() - started < 15000) await settle(60);
      var original = document.querySelector('[data-myx-room-preview-cta]');
      if (!running && !pending && original) original.click();
      preview.disabled = false;
    });
    wrap.append(preview);
    var error = element('p', 'myx-size-error'); error.setAttribute('role', 'status'); error.hidden = true; wrap.append(error);
    return wrap;
  }
  function paint(value) {
    if (!host?.isConnected) return;
    value = value || pending || current(); var kind = shape(); if (!value || !kind) return;
    host.querySelectorAll('.myx-size-card').forEach(function (card, index) {
      var size = dimensions(lengths[index], kind), recommended = index === (square(kind) ? 2 : 3);
      text(card.querySelector('.myx-size-dimensions'), dimensionLabel(size));
      attr(card, 'aria-pressed', equal(value, size));
      attr(card, 'aria-label', labels[names[index]] + ', ' + dimensionLabel(size) + (recommended ? ', ' + labels.recommended : ''));
      card.querySelector('.myx-size-badge').hidden = !recommended;
      attr(card, 'data-recommended', recommended);
    });
    var range = host.querySelector('input[type="range"]'), min = square(kind) ? 12 : 18;
    attr(range, 'min', min); attr(range, 'max', sliderMax); attr(range, 'step', square(kind) ? 0.1 : 0.2);
    var long = Math.max(min, Math.min(sliderMax, Math.max(value.width, value.height)));
    if (range.value !== String(long)) range.value = String(long);
    attr(range, 'aria-valuetext', number(value.width) + ' by ' + number(value.height) + ' inches');
    range.style.setProperty('--myx-scale-progress', ((long - min) / (sliderMax - min) * 100) + '%');
    text(host.querySelector('output'), dimensionLabel(value));
    text(host.querySelector('.myx-size-summary-value'), dimensionLabel(value));
    var native = fields();
    ['width', 'height'].forEach(function (axis, index) {
      var input = host.querySelector('#myx-unified-' + axis);
      if (document.activeElement !== input) input.value = number(value[axis]);
      // Preserve CPB's counter bounds; the slider is capped at 96 inches without changing saved/manual dimensions.
      if (native && native.factor === 1) {
        ['min', 'max', 'step'].forEach(function (key) { if (native.inputs[index].hasAttribute(key)) attr(input, key, native.inputs[index].getAttribute(key)); else input.removeAttribute(key); });
      }
      var controls = input.closest('.myx-size-counter');
      controls.firstElementChild.disabled = value[axis] <= Number(input.min || 0);
      controls.lastElementChild.disabled = input.max !== '' && value[axis] >= Number(input.max);
    });
  }
  function waitFor(test, kind) {
    var started = Date.now();
    return new Promise(function (resolve, reject) {
      function check() {
        if (shape() !== kind) { reject(new Error('Shape changed')); return; }
        var result = test(); if (result) { resolve(result); return; }
        if (Date.now() - started > 7000) { reject(new Error('Size update timed out')); return; }
        setTimeout(check, 60);
      }
      check();
    });
  }
  function settle(ms) { return new Promise(function (resolve) { setTimeout(resolve, ms); }); }
  async function commitField(index, value, kind) {
    if (shape() !== kind) throw new Error('Shape changed');
    var input = fields()?.inputs[index]; if (!input || fields().factor !== 1) throw new Error('Inch controls unavailable');
    if (Math.abs(Number(input.value) - value) < 0.005) return;
    Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(input, String(value));
    input.dispatchEvent(new Event('input', { bubbles: true })); input.dispatchEvent(new Event('change', { bubbles: true }));
    await settle(30);
    input.dispatchEvent(new FocusEvent('focusout', { bubbles: true }));
    input.closest('.cpb-counter')?.querySelector('.cpb-counter-apply')?.click();
    await settle(350);
  }
  async function commit(value, kind) {
    var index = lengths.findIndex(function (long) { return equal(value, dimensions(long, kind)); });
    if (index >= 0) {
      if (!active(option(IDs.preset))) option(IDs.preset)?.click();
      await waitFor(function () { return active(option(IDs.preset)) && window.__MAYTRIX_SIGNATURE_SIZES__?.getChoices(kind).some(function (choice) { return choice.optionId && equal(choice, value); }); }, kind);
      var choice = window.__MAYTRIX_SIGNATURE_SIZES__.getChoices(kind).find(function (item) { return equal(item, value); });
      if (!active(option(choice.optionId))) option(choice.optionId)?.click();
      await waitFor(function () { return equal(current(), value); }, kind);
      await settle(350);
      return;
    }
    if (!active(option(IDs.custom))) option(IDs.custom)?.click();
    await waitFor(function () { return active(option(IDs.custom)) && category(IDs.units); }, kind);
    if (!active(option(IDs.inches))) option(IDs.inches)?.click();
    await waitFor(function () { return active(option(IDs.inches)) && fields()?.factor === 1; }, kind);
    await commitField(0, value.width, kind); await commitField(1, value.height, kind);
    await waitFor(function () { return equal(current(), value); }, kind);
  }
  function queue(value, delay) {
    if (!shape() || !Number.isFinite(value.width) || !Number.isFinite(value.height)) return;
    pending = { width: value.width, height: value.height, kind: shape() };
    host.querySelector('.myx-size-error').hidden = true; paint(pending);
    clearTimeout(debounce); debounce = setTimeout(flush, delay);
  }
  async function flush() {
    if (running || !pending) return;
    running = true;
    try {
      while (pending) {
        var target = pending;
        if (target.kind !== shape()) { pending = null; break; }
        if (!equal(current(), target)) await commit(target, target.kind);
        if (pending === target) pending = null;
      }
    } catch (error) {
      if (!pending || pending.kind === target?.kind) pending = null;
      if (host?.isConnected && shape() === lastShape && error.message !== 'Shape changed') {
        text(host.querySelector('.myx-size-error'), labels.error); host.querySelector('.myx-size-error').hidden = false;
      }
    } finally { running = false; paint(); if (pending) debounce = setTimeout(flush, 0); }
  }
  function refresh() {
    var mode = category(IDs.mode), kind = shape();
    if (!mode || !kind || !current()) return;
    if (lastShape && lastShape !== kind) { pending = null; clearTimeout(debounce); }
    lastShape = kind;
    if (!host?.isConnected) { host = make(); mode.append(host); }
    if (!mode.classList.contains('myx-size-native-mode')) mode.classList.add('myx-size-native-mode');
    document.getElementById('product-builder').classList.add('myx-unified-sizing');
    if (!running) paint();
  }
  function schedule() { if (!refreshTimer) refreshTimer = setTimeout(function () { refreshTimer = 0; refresh(); }, 60); }
  function start() {
    new MutationObserver(function (mutations) {
      if (mutations.some(function (mutation) { return !mutation.target.closest?.('.myx-unified-size'); })) schedule();
    }).observe(document.getElementById('product-builder') || document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-pressed', 'aria-checked', 'data-maytrix-shape'] });
    document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', schedule);
    document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', schedule);
    document.addEventListener('change', schedule); schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
}());
